import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListViewPPG from "./ScrollableListViewPPG";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getCurrency } from "components/Navbar/NavUserBox";
import { BaseServiceURLs } from "BaseServiceURLs";
import ScrollableListView from "./ScrollableListView";
import { isBrowser, isMobile, isTablet } from "react-device-detect";
import Footer from "../Home/Footer";
import { isProviderKeyAllowed, getSortedAllowedProviderKeys } from "./FilterSearch";

const LiveCasino = (props) => {
  const {
    user,
    games,
    allGames,
    loggedIn,
    liveGames,
    UpdateLiveGame,
    UpdateLiveGameProviders,
  } = props;
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [FilterSearchValue, setFilterSearchValue] = useState("");
  const [currentProvider, setCurrentProvider] = useState("");
  const [selectedProviders, setSelectedProviders] = useState([]);

  let params = GetParams();
  const navigate = useNavigate();
  const location = useLocation();

  function GetParams() {
    let params = useParams();
    return params;
  }

  // Provider seçimini localStorage'da saklama için key'ler. Hesaba özel (userIdentity)
  // saklanır ki aynı tarayıcıda farklı bir hesaba giriş yapıldığında önceki hesabın
  // seçimi yeni hesaba sızmasın. Logout'ta authentication.user her zaman null olduğu
  // için (bkz. authentication.reducer.js LOGOUT case) misafir durumu güvenle ayrışır.
  const userIdentity = user && user._id ? user._id : "guest";
  const getProviderKey = () => `current_live_provider_${userIdentity}_${location.pathname}`;
  const getSelectedProvidersKey = () => `selected_live_providers_${userIdentity}_${location.pathname}`;

  let casinoId = BaseServiceURLs.PRAGMATIC_CASINO_ID
    ? BaseServiceURLs.PRAGMATIC_CASINO_ID
    : "ppcdx00000014043";
  let url = BaseServiceURLs.PRAGMATIC_CASINO_LIVE
    ? BaseServiceURLs.PRAGMATIC_CASINO_LIVE
    : "prelive-dga0.pragmaticplaylive.net"; //"dga.pragmaticplaylive.net";



  useEffect(() => {
    setFilterSearchValue("");
    if (
      params.ProviderId &&
      isProviderKeyAllowed(params.ProviderId, games, props.permissions, loggedIn)
    ) {
      setCurrentProvider(params.ProviderId);
    }
  }, [params.ProviderId]);

  useEffect(() => {
    if (
      games &&
      params &&
      params.ProviderId &&
      games.hasOwnProperty(params.ProviderId) &&
      isProviderKeyAllowed(params.ProviderId, games, props.permissions, loggedIn)
    ) {
      setCurrentProvider(params.ProviderId);
    }
    try {
      if (games) {
        const _allGames = allGames;
        const aa = getFilterTimelessTech("live-casino");
      }
    } catch (error) { }
  }, [games, params.ProviderId]);
  const getFilterTimelessTech = (subtype, type) => {
    return Object.keys(games).filter((x) => {
      if (x.includes("timelesstech")) {
        return games[x].length > 0
          ? subtype
            ? games[x][0].subtype == subtype
            : true && subtype
              ? games[x][0].type == type
              : true
          : false;
      }
      return x.includes("timelesstech");
    });
  };



  // sockets state değiştiğinde useEffect çalışır

  function onMessageWebsocket(data) {
    if (data.hasOwnProperty("tableKey") && Object.keys(data).length == 1) {
      // data["tableKey"].forEach((x) => subscribeKey(x));
    } else if (data.hasOwnProperty("tableName")) {
      processTable(data);
      //   document.querySelector(".loader-container").style.display = "none";
    }
  }
  const processTable = (data) => {
    // İlgili id'ye sahip elementi bulma
    var limitdiv = document.getElementById("ppg-limitbet" + data.tableId);
    var accountdiv = document.getElementById("ppg-account" + data.tableId);
    //  var poster = document.getElementById("ppg-poster" + data.tableId);

    if (accountdiv) {
      // Element varsa içeriğini güncelle
      accountdiv.innerHTML =
        "<div class='flex flex-row items-center'>" +
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor' class='w-2 h-2'> <path fill-rule='evenodd' d='M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z' clip-rule='evenodd' /> </svg>" +
        (data.availableSeats
          ? `${data.totalSeatedPlayers}/${Math.abs(
            data.totalSeatedPlayers - data.availableSeats
          )}`
          : data.totalSeatedPlayers) +
        "</div>";
      accountdiv.style.opacity = 1;
    }
    if (limitdiv) {
      if (data.hasOwnProperty("tableLimits")) {
        // Element varsa içeriğini güncelle
        const cur = getCurrency(data.currency);
        const min = data.tableLimits.minBet + cur; //.replace("IQD", "TND");
        const max = data.tableLimits.maxBet + cur; //.replace("IQD", "TND");
        limitdiv.innerHTML = "<span>" + `${min} - ${max}` + "</span>";
        limitdiv.style.opacity = 1;
      } else {
      }
    }
    /*  if (poster && data.tableImage) {
      poster.src = data.tableImage;
    }
 
  */
  };

  useEffect(() => {
    getGameProviders();
    /*
        if (
          !params?.ProviderId &&
          props?.permissions?.PRAGMATIC_LIVECASINO_ACCESS?.Value
        ) {
          navigate("/live-casino/537");
        }*/
  }, []);

  useEffect(() => {
    // getGames(params.ProviderId);
    getGames(params.ProviderId);

    setFilterSearchValue("");
  }, [params.ProviderId]);

  useEffect(() => {
    getGames(params.ProviderId);
  }, []);

  // Provider hafızası: kaydedilmiş seçim geri yüklenir, ama yetki durumu her zaman
  // önceliklidir. games/permissions/loggedIn/userIdentity her değiştiğinde (login,
  // logout, hesap değişimi, yetki güncellemesi) hafızadan gelen seçim tek doğruluk
  // kaynağı olan getSortedAllowedProviderKeys ile yeniden doğrulanır; artık izinli
  // olmayan ya da başka bir hesaba ait bir provider asla state'e yansımaz, bunun
  // yerine ilk izinli provider'a düşülür.
  useEffect(() => {
    if (!games || params.ProviderId) return;
    const allowed = getSortedAllowedProviderKeys(games, props.permissions, loggedIn);
    if (allowed.length === 0) return;

    const savedProvider = localStorage.getItem(getProviderKey());
    let savedSelected = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(getSelectedProvidersKey()));
      if (Array.isArray(parsed)) savedSelected = parsed;
    } catch (error) {
      console.error('Error parsing saved selected live providers:', error);
    }

    const validSelected = savedSelected.filter((p) => allowed.includes(p));
    const nextSelected = validSelected.length > 0 ? validSelected : [allowed[0]];
    const selectedChanged =
      nextSelected.length !== selectedProviders.length ||
      nextSelected.some((p, i) => p !== selectedProviders[i]);
    if (selectedChanged) {
      setSelectedProviders(nextSelected);
    }

    const nextCurrent =
      savedProvider && allowed.includes(savedProvider) ? savedProvider : nextSelected[0];
    if (currentProvider !== nextCurrent) {
      setCurrentProvider(nextCurrent);
    }
  }, [games, props.permissions, loggedIn, params.ProviderId, userIdentity, location.pathname]);

  const getGameProviders = async () => {
    setLoading(true);
    await GameService.GET_LIVE_GAME_PROVIDERS()
      .then((res) => {
        setLoading(false);
        UpdateLiveGameProviders(res);
        //UpdateGames(res);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const getGames = async () => {
    setLoading(true);
    await GameService.GET_LIVE_GAMES(params?.ProviderId)
      .then((res) => {
        setLoading(false);
        UpdateLiveGame(res);
        //UpdateGames(res);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  let isFetching = false;

  const getGamesMore = async () => {
    setLoading(true);
    if (!isFetching) {
      isFetching = true;
      await GameService.GET_LIVE_GAMES(params?.ProviderId, null, page + 1)
        .then((res) => {
          setPage(page + 1);

          const idSet = new Set(liveGames.map((item) => item._id));
          const uniqueNewArray = res.filter((item) => !idSet.has(item._id));

          UpdateLiveGame([...liveGames, ...uniqueNewArray]);
          setLoading(false);

          //UpdateGames(res);
        })
        .catch((err) => {
          setLoading(false);
        });
      setTimeout(() => {
        isFetching = false;
      }, 500);
    }
  };

  const pb = require("../../../assets/img/banners/lc2.png");
  const pragmaticNotCasino = ["1301", "1302", "1320"];
  const handleMultipleProviderSelect = (providers) => {
    setSelectedProviders(providers);
    // İlk seçili provider'ı current provider olarak ayarla (geriye uyumluluk için)
    if (providers.length > 0) {
      setCurrentProvider(providers[0]);
    }
  };

  // Provider değişikliklerini localStorage'a kaydet (hesaba özel key ile)
  useEffect(() => {
    if (currentProvider) {
      localStorage.setItem(getProviderKey(), currentProvider);
    }
  }, [currentProvider, location.pathname, userIdentity]);

  useEffect(() => {
    if (selectedProviders.length > 0) {
      localStorage.setItem(getSelectedProvidersKey(), JSON.stringify(selectedProviders));
    }
  }, [selectedProviders, location.pathname, userIdentity]);

  const priorityPragmatic = ["94572", "108493", "108716", "93509", "108601", "108450", "108411", "89916", "93210", "", "108342", "94571", "94569", "94570", "93507", "93504", "93501", "93508", "93506", "108582", "89951", "108799"]

  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_LIVECASINO")}</title>
          </Helmet>

          {games && (
            <div className={currentProvider}>
              <ScrollableListView
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                pb={pb}
                title={t("TITLE_LIVECASINO")}
                provider={currentProvider}
                setProvider={setCurrentProvider}
                selectedProviders={selectedProviders}
                setSelectedProviders={handleMultipleProviderSelect}
                data={
                  (games && (selectedProviders.length > 0 ?
                    // Çoklu provider seçimi varsa, tüm seçili provider'ların oyunlarını birleştir
                    selectedProviders.reduce((allGames, provider) => {
                      if (games.hasOwnProperty(provider) && isProviderKeyAllowed(provider, games, props.permissions, loggedIn)) {
                        let providerGames = [...games[provider]];
                        // Pragmatic provider için oyunları priorityPragmatic listesine göre sırala
                        if (provider === "pragmatic") {
                          providerGames = games[provider].sort((a, b) => {
                            // Oyun ID'lerini priorityPragmatic listesinde ara
                            const aIndex = priorityPragmatic.indexOf(a.id?.toString());
                            const bIndex = priorityPragmatic.indexOf(b.id?.toString());

                            // Her ikisi de öncelikli listede varsa, öncelik sırasına göre sırala
                            if (aIndex !== -1 && bIndex !== -1) {
                              return aIndex - bIndex;
                            }

                            // Sadece a öncelikli listede varsa, a önce gelsin
                            if (aIndex !== -1 && bIndex === -1) {
                              return -1;
                            }

                            // Sadece b öncelikli listede varsa, b önce gelsin
                            if (aIndex === -1 && bIndex !== -1) {
                              return 1;
                            }

                            // İkisi de öncelikli listede yoksa, ID'ye göre ters sırala
                            return (b.id || 0) - (a.id || 0);
                          });
                        }
                        return [...allGames, ...providerGames];
                      }
                      return allGames;
                    }, [])
                    : games.hasOwnProperty(currentProvider) &&
                      isProviderKeyAllowed(currentProvider, games, props.permissions, loggedIn)
                      ? (() => {
                        let providerGames = [...games[currentProvider]];
                        // Pragmatic provider için oyunları priorityPragmatic listesine göre sırala

                        if (currentProvider === "pragmatic") {
                          providerGames = providerGames.sort((a, b) => {
                            // Oyun ID'lerini priorityPragmatic listesinde ara
                            const aIndex = priorityPragmatic.indexOf(a.id?.toString());
                            const bIndex = priorityPragmatic.indexOf(b.id?.toString());

                            // Her ikisi de öncelikli listede varsa, öncelik sırasına göre sırala
                            if (aIndex !== -1 && bIndex !== -1) {
                              return aIndex - bIndex;
                            }

                            // Sadece a öncelikli listede varsa, a önce gelsin
                            if (aIndex !== -1 && bIndex === -1) {
                              return -1;
                            }

                            // Sadece b öncelikli listede varsa, b önce gelsin
                            if (aIndex === -1 && bIndex !== -1) {
                              return 1;
                            }

                            // İkisi de öncelikli listede yoksa, ID'ye göre ters sırala
                            return (b.id || 0) - (a.id || 0);
                          });
                        }

                        return providerGames;
                      })()
                      : []))
                    ?.filter((x) => {

                      switch (x._midleware) {
                        case 'matgame':
                          if (x.game_type === 2 && x.is_active === 1) {
                            return true;
                          }
                           else
                            return false;
                        case 'innova':
                          if (x.enabled === 1 && x.subtype == 'live-casino') {
                            return true;
                          }
                          return false;
                          break;
                        case 'gasea':
                          if (x.categoryCode.toLowerCase().includes('live')||x.categoryCode.toLowerCase().includes('livegrand')||x.categoryCode.toLowerCase().includes('poker')) {
                            return true;
                          }
                          return false;
                          break;
                        default:
                          return true;
                          break;
                      }

                    })
                    .filter((x) => {
                      //   debugger;
                      if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider).includes('-fundist')
                      ) {
                        if (x.Trans) {
                          const _n = x.Trans.hasOwnProperty(t("LANG"))
                            ? x.Trans[t("LANG")]
                            : x.Trans.en;

                          return _n
                            .toLocaleLowerCase()
                            .includes(
                              FilterSearchValue?.toLocaleLowerCase()
                            );
                        } else {
                          debugger;
                        }
                      } else {
                        let _val = (params.ProviderId
                          ? params.ProviderId
                          : currentProvider) == "pragmatic-casino"
                          ? "gameName"
                          : currentProvider == "smartsoft"
                            ? "Name"
                            : (currentProvider.includes('timeless') || currentProvider.includes('timeless'))
                              ? "title"
                              : "name";
                        if (x._midleware == 'innova') {
                          _val = 'title';
                        }
                        if (x._midleware == 'gasea') {
                          _val = 'title';
                        }
                        if (x._midleware == 'matgame') {
                          _val = 'name';
                        }

                        const __XXX = x[_val]
                          ?.toLocaleLowerCase()
                          .includes(FilterSearchValue?.toLocaleLowerCase());
                        return __XXX
                      }
                    })
                    .filter((x) => {
                      if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider) == "pragmatic-casino"
                      ) {
                        return (
                          x.gameTypeID != "lg" && x.gameTypeID != "rgs-vsb"
                        );
                      } else if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider) == "iconix"
                      ) {
                        return x.type == "slots";
                      } else if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider).includes('-fundist')
                      ) {
                        if (isMobile && x.MobilePageCode) {
                          return true;
                        }
                        if (!isMobile && x.PageCode) {
                          return true;
                        }
                        return false;
                      } else if (
                        isMobile &&
                        (x.provider == "CSGI" ||
                          x.provider == "CSIM" ||
                          x.provider == "ZEUS" ||
                          x.provider == "CSGG" ||
                          x.provider == "KNTC" ||
                          x.provider == "VGRG")
                      ) {
                        if (x.platforms?.find((x) => x == "MOBILE")) {
                          return true;
                        } else {
                          return false;
                        }
                      } else {
                        return true;
                      }
                    })
                    .filter((x) => {
                      /*
                       if (user?.Currency == 'TRY') {
                         return true;
                       }*/
                      if (x._midleware == "innova") {
                        return true;
                      }
                      return true; // PARA KONTROLÜ İPTAL
                      const userCurrency = user?.Currency?.toString()?.toUpperCase?.();
                      if (!userCurrency) return true;
                      const currencies = Array.isArray(x?._currencies) ? x._currencies : [];
                      return currencies.some((currency) => (currency ?? "").toString().toUpperCase() === userCurrency);
                    }) || []
                }
              />

              <Footer />

            </div>
          )}
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { liveGames, games } = game;
  return {
    user,
    loggedIn,
    liveGames,
    games,
    permissions,
    permissionsAll,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateLiveGame: (data) => dispatch(gameAction.UpdateLiveGame(data)),
    UpdateLiveGameProviders: (data) =>
      dispatch(gameAction.UpdateLiveGameProviders(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveCasino);
